module.exports = __webpack_public_path__ + "img/card_group.e9814d71.png";